module.exports = __webpack_public_path__ + "static/img/LL-2.16e9f46a.png";